module.exports = "img/16.d46173.webp";